export const ApiDef_PertinentCategory = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map